import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const verticalLinePlugin = {
  id: 'verticalLineOnHover',
  afterDraw: (chart) => {
    if (chart.tooltip?._active?.length) {
      const ctx = chart.ctx;
      const activePoint = chart.tooltip._active[0];
      const x = activePoint.element.x;
      const topY = chart.scales.y.top;
      const bottomY = chart.scales.y.bottom;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(0, 0, 0, 0.2)';
      ctx.stroke();
      ctx.restore();
    }
  },
};

const createGradient = (ctx, chartArea) => {
  if (!chartArea) {
    return null;
  }
  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
  gradient.addColorStop(0, 'rgba(0, 0, 0, 0.14)');
  gradient.addColorStop(0.9, 'rgba(0, 0, 0, 0)');
  return gradient;
};

const getOrdinalSuffix = (num) => {
  if (typeof num !== 'number') {
    return '';
  }
  const s = ["th", "st", "nd", "rd"];
  const v = num % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
};

const AttentionSpanLineChart = ({ chartData, attentionIntervalDuration, duration }) => {
  const dataPoints = chartData || [];
  const durationInMinutes = duration || 0;

  const labels = dataPoints.map((_, index) => {
    const start = index * (attentionIntervalDuration || 0);
    const isLastIndex = index === dataPoints.length - 1;
    const end = isLastIndex ? duration : (index + 1) * (attentionIntervalDuration || 0);
    return `${start}-${end}`;
  });


  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Attention Span',
        data: dataPoints,
        fill: true,
        borderColor: '#000000',
        backgroundColor: (context) => {
          const { chart } = context;
          const { ctx, chartArea } = chart;
          return createGradient(ctx, chartArea);
        },
        borderWidth: 0.75,
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 6,
        pointHoverBackgroundColor: '#000000',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => {
            return `Between ${tooltipItems[0].label} min`;
          },
          label: (context) => {
            return `Attention: ${context.parsed.y.toFixed(2)}%`;
          },
        },
        displayColors: false,
        titleFont: { size: 12 , weight : 'normal' },  
        bodyFont: { size: 12 , weight : 'normal' },   
      },

    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 20,
          callback: (value) => value + '%',
        },
        grid: {
          display: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#6c757d',
        },
        title: {
          display: true,
          text: `Period Duration: ${durationInMinutes} (Min)`,
          offsetY: 2,
          color: '#6c757d',
          font: {
            size: 13,
            weight: 'normal',
          },
          padding: { top: 12 },
        },
      },
    },
  };

  return <Line options={options} data={data} plugins={[verticalLinePlugin]} />;
};

export default AttentionSpanLineChart;